import { useState } from "react";
import CompanyTable from "../Manage/CompanyTable";
import IndexCompanyTable from "../Manage/IndexCompanyTable";
import SectorTable from "../Manage/SectorTable";
import EasyTabs from "../../Components/EasyTabs";
import useTabState from "../../contexts/useTabState";
import HolidaysTable from "../Manage/HolidaysTable";
import AIPromptsTable from "../Manage/AIPromptsTable";



const tabs = [
  { label: "Compay", icon: "share", value: "company" },
  { label: "Sector", icon: "share", value: "sector" },
  { label: "Index Comany", icon: "envelope-open", value: "index-company" },
  { label: "Holidays", icon: "envelope-open", value: "holidays" },
  { label: "AI Prompts", icon: "robot", value: "ai-prompts" },

] as const;

type TabValue = (typeof tabs)[number]["value"];

const Settings: React.FC = () => {
  const [tab, setTab] = useTabState<TabValue>("SITE_SETTINGS", "company");
  const [data, setData] = useState<any>({});



  const displayContent = () => {
    switch (tab) {
      case "company":
        return <CompanyTable />;
      case "sector":
        return <SectorTable />;
      case "index-company":
        return <IndexCompanyTable />;
      case "holidays":
        return <HolidaysTable />;
      case "ai-prompts":
        return <AIPromptsTable />;

      default:
        return <CompanyTable />;
    }
  };

  return (
    <div className="p-3">
      <EasyTabs
        tags={tabs}
        tagFlag={tab}
        setTagFlag={(v: any) => setTab(v as TabValue)}
      />

      <div className="settings-contentt">{displayContent()}</div>
    </div>
  );
};


export default Settings